import React from 'react';
import { useTranslation } from 'react-i18next';

import PrimaryButton from 'components/layout/buttons/PrimaryButton';
import translations from 'services/translations/translations';
import { LEFT, RIGHT } from 'services/enums/sides';

const ActionButtons = ({
  cancel,
  locked,
  openPreview,
  remove,
  save,
  saveButtonText,
}: {
  cancel: () => void;
  locked: boolean;
  // Opens the PDF preview of the offer, next to the other buttons
  openPreview?: () => void;
  remove?: () => void | undefined;
  save: () => void;
  saveButtonText: string;
}): JSX.Element => {
  const { t } = useTranslation([translations.common, translations.offers]);

  const offerIsLocked = () => locked;

  return (
    <>
      {/* Cancel and remove at the left edge, away from saving */}
      <PrimaryButton className="button-one-line" float={LEFT} onClick={cancel}>
        {t(`${translations.common}:Cancel`).toLocaleUpperCase()}
      </PrimaryButton>
      {remove === undefined || offerIsLocked() ? null : (
        <PrimaryButton
          className="button-one-line"
          float={LEFT}
          onClick={remove}
        >
          {t(`${translations.common}:Remove`).toLocaleUpperCase()}
        </PrimaryButton>
      )}
      {offerIsLocked() ? null : (
        <PrimaryButton className="button-one-line" float={RIGHT} onClick={save}>
          {saveButtonText.toLocaleUpperCase()}
        </PrimaryButton>
      )}
      {openPreview === undefined ? null : (
        <PrimaryButton
          className="button-one-line"
          float={RIGHT}
          onClick={openPreview}
        >
          {t(`${translations.offers}:pdfPreview.Open`).toLocaleUpperCase()}
        </PrimaryButton>
      )}
      <div className="clearfix" />
    </>
  );
};

export default ActionButtons;
